import React from 'react'

export default function HorizontalLoading() {
  return (
    <div class="hr-loading-wrapper">
      <div class="loading-bar"></div>
    </div>
  )
}
